import { useRouter } from 'next/router';

import { useGetPaginateDoctorCarousel } from '@api/promotion/promotion.rq';

import NonOtcPlpVeticalCardShimmer from '@com/shared/cards/plpCard/verticalPlpCards/nonOtcPlpVeticalCardShimmer';

import { routeList } from '@routes/routeList';

import Pagination from '@com/shared/ocs/Pagination';
import DoctorCard from '@com/shared/ocs/horizontal-doctor-card';
import { Fragment } from 'react';
import InPersonBookingButton from '@com/shared/cards/in-person-booking-button';
import OcsBookingButton from '@com/shared/cards/ocs-booking-button';
import { DoctorListTypeEnum } from '@models/doctor-list';

const DoctorTab = () => {
  const { query, push } = useRouter();
  const isInNobatPage = query?.fromNobat;
  const { data, isLoading } = useGetPaginateDoctorCarousel({
    carouselId: query?.id,
    search: query?.search,
    pageNumber: query?.pageNumber,
    pageSize: query?.pageSize,
  });

  const pageSize = Number(query.pageSize as string);

  const isShownPagination = data?.totalCount / pageSize > 1;

  return (
    <>
      <div className="flex flex-col gap-4 px-4 pb-4 pt-2">
        {isLoading && (
          <>
            {[...Array(8).keys()].map((item) => (
              <NonOtcPlpVeticalCardShimmer key={item} />
            ))}
          </>
        )}

        {data?.queryResult?.length > 0 &&
          data?.queryResult?.map((item) => {
            return (
              <DoctorCard
                key={item.doctorId}
                item={item}
                doctorListType={isInNobatPage ? DoctorListTypeEnum.NOBAT : null}
                onClick={() =>
                  push(
                    `${routeList?.doctorProfile}/${item?.doctorId}${isInNobatPage ? '?fromNobat=true' : ''}`,
                  )
                }
                buttonComponent={({ routeLoadingId, setRouteLoadingId }) => (
                  <Fragment>
                    {!!isInNobatPage ? (
                      <InPersonBookingButton
                        isLoading={isLoading}
                        doctorId={item?.recId ?? item?.doctorId}
                        fullName={item?.fullName}
                        citiesLength={item?.cities?.length}
                        isJustNobatButton={!!isInNobatPage}
                      />
                    ) : (
                      <OcsBookingButton
                        isLoading={isLoading}
                        recId={item?.recId}
                        activityStatus={item?.activityStatus}
                        routeLoadingId={routeLoadingId}
                        setRouteLoadingId={setRouteLoadingId}
                      />
                    )}
                  </Fragment>
                )}
              />
            );
          })}
        {isShownPagination && (
          <Pagination lastPage={Math.floor(data?.totalCount / pageSize) + 1} />
        )}
      </div>
    </>
  );
};

export default DoctorTab;
